import { useState } from "react"
import Card from "./Card"

export default function Container({ items }) {
  const [openIndex, setOpenIndex] = useState(null)

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  return (
    <div className="w-full sm:flex sm:gap-5">
      <div className="flex-1 flex flex-col gap-5">
        {items.map((item, index) => (
          <Card
            key={index}
            question={item.question}
            answer={item.answer}
            index={index}
            isOpen={openIndex === index} onToggle={() => handleToggle(index)}
          />
        ))}
      </div>
    </div>
  )
}